export default __webpack_public_path__ + "static/banner-tips-on-paying-for-your-new-car-240abf5d5d532cabc7b4306fd041edf2.jpg";